import { Stack } from '@mui/material';

import HomeIcon from '@/components/Icons/HomeIcon';
import { BasetenPageEnum } from '@/routes';
import Logo from '@/sections/GlobalHeader/Left/Logo';
import WorkspaceLink from '@/sections/GlobalHeader/Left/WorkspaceLink';

import { useWorkspaceSection } from '../hooks';
import { AppLink, MenuItem, Section } from '../styled';
import { WorkspaceSections } from '../types';

function Header() {
  const selectedSection = useWorkspaceSection();

  return (
    // NOTE: please to do update this spacing
    <Section gap={1.625} sx={{ pt: 1.5 }}>
      <Stack direction="row" gap={2} alignItems="center">
        <Logo variant="icon" />
        <WorkspaceLink
          displayTextSx={{
            maxWidth: 112,
          }}
        />
      </Stack>
      <MenuItem selected={selectedSection === WorkspaceSections.Overview}>
        <AppLink
          page={BasetenPageEnum.WorkspaceTeams}
          params={{
            section: WorkspaceSections.Overview,
          }}
        >
          <HomeIcon
            color={selectedSection === WorkspaceSections.Overview ? 'inherit' : 'secondary'}
          />{' '}
          Overview
        </AppLink>
      </MenuItem>
    </Section>
  );
}

export default Header;
